import { useMemo } from "react";
import { useUser } from "./user";

export function get(user, flag) {
  if (!user.flags) {
    // For backwards compatibility with login sessions before the release of flags, disable everything if there are none.
    return false;
  }

  return user.flags[flag];
}

export function isOn(user, flag) {
  return get(user, flag);
}

export function isOff(user, flag) {
  return !isOn(user, flag);
}

const NOTIFICATION_FLAGS = ['FORM_REVIEWERS_ENABLED', 'SCALE_PRINT_ENABLED'];

export function hasNotifications(user) {
  return NOTIFICATION_FLAGS.some(flag => isOn(user, flag));
}

export function useFlag(flag) {
  const user = useUser();

  return useMemo(() => ({
    enabled: isOn(user, flag),
    disabled: isOff(user, flag)
  }), [user]);
}